import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffPapersManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      checkbox_marked_ids: [],
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.approve = this.approve.bind(this);
    this.approveAll = this.approveAll.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.AlertColumn = this.AlertColumn.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeletas/gestor', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/papeleta/editar/' + cell;

    if (row.alerts === 'Sim') {
      var botao = (
        <div className="btn-group">
          <Link className={'btn btn-primary btn-sm button-inline'} to={url}>
            <i className="fa fa-fw fa-pencil"></i>
          </Link>
        </div>
      );
    } else {
      var botao = (
        <div className="btn-group">
          <Link className={'btn btn-primary btn-sm button-inline'} to={url}>
            <i className="fa fa-fw fa-pencil"></i>
          </Link>
        </div>
      );
    }

    return botao;
  }


  AlertColumn (cell, row) {

    if (cell === 'Sim') {
      var botao = (
        <span className="label label-danger" style={{ fontSize: 14 }}>
          {this.locale.general.sim}
        </span>
      );
    } else {
      var botao = (
        <span className="label label-success" style={{ fontSize: 14 }}>
          {this.locale.general.nao}
        </span>
      );
    }

    return botao;
  }

  delete (event) {
    var fira_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Papeletas.ListaDePapeletasPendentesGestor.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/' + fira_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fira_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(fira_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == fira_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  // Fetch salvando a edição
  approve(id) {
    if (window.confirm(this.locale.Papeletas.ListaDePapeletasPendentesGestor.trocarStatus)){
      this.handleAlert('', '', 'open');

      var header = this.refs.request_api.header('application/json');
      var self = this;

      var datasave = {
        bypass_approval: 0,
        id: id,
      };

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/gestor/aprovar/', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch salvando a edição
  approveAll() {
    if (window.confirm(this.locale.Papeletas.ListaDePapeletasPendentesGestor.trocarStatus)){
      this.handleAlert('', '', 'open');

      var header = this.refs.request_api.header('application/json');
      var self = this;

      var datasave = this.state.checkbox_marked_ids;

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeletas/aprovar/status', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({data: responseJson.data});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  onRowSelect(row, isSelected, e) {
    let checkbox_marked_ids = this.state.checkbox_marked_ids;
    if (isSelected) {
      checkbox_marked_ids.push(row.id);
    } else {
      for (let i = 0; i < checkbox_marked_ids.length; i++) {
        if(checkbox_marked_ids[i] === row.id) {
          checkbox_marked_ids.splice(i, 1);
        }
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids});
  }

  onSelectAll(isSelected, rows) {
    let checkbox_marked_ids = [];
    if (isSelected) {
      for (let i = 0; i < rows.length; i++) {
        checkbox_marked_ids.push(rows[i].id);
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids});
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Papeletas.ListaDePapeletasPendentesGestor.titulo}</h3>
      <hr/>
      <button type="button" onClick={this.approveAll} className="btn btn-success btn-block btn-lg"><i className="fa fa-fw fa-check"></i> {this.locale.Papeletas.ListaDePapeletasPendentesGestor.botaoAprovarSelecionados}</button>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.semPapeletasPendentes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}
      selectRow={ {
        mode: 'checkbox',
        clickToSelect: true,
        onSelect: this.onRowSelect,
        onSelectAll: this.onSelectAll
      } }
      >
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Matricula}</TableHeaderColumn>
        <TableHeaderColumn dataField="month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Referencia}</TableHeaderColumn>
        <TableHeaderColumn dataField="alerts" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.AlertColumn}>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Alertas}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='140'>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffPapersManager;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/StaffPapersManager.js